import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, LOCALE_ID } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { PoModule, PoToolbarModule, PoFieldModule, PoModalModule, PoInfoModule } from '@po-ui/ng-components';
import { RouterModule } from '@angular/router';
import { LoginModule } from './login/login.module';
import { HomeModule } from './home/home.module';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { PreNotaModule } from './pre-nota/pre-nota.module';
import { CotacaoModule } from './cotacao/cotacao.module';
import { ReembolsoDespesaModule } from './reembolso-despesas/reembolso-despesas.module';
import { InterceptorService } from './authentication/interceptor/interceptor.service';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import localePt from '@angular/common/locales/pt';
import { HashLocationStrategy, LocationStrategy, registerLocaleData } from '@angular/common';

registerLocaleData(localePt, 'pt-BR');
@NgModule({
  declarations: [
    AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    PoModule,
    RouterModule.forRoot([]),
    LoginModule,
    HomeModule,
    PoToolbarModule,
    HttpClientModule,
    PreNotaModule,
    CotacaoModule,
    ReembolsoDespesaModule,
    PoModalModule,
    PoFieldModule,
    PoInfoModule,
    ReactiveFormsModule,
    FormsModule,
  ],
  providers: [
    {
      provide: LOCALE_ID, useValue: 'pt-BR'
    },
    {
      provide: HTTP_INTERCEPTORS, useClass: InterceptorService, multi: true
    },
    { provide: LocationStrategy, useClass: HashLocationStrategy}
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
